import { render, staticRenderFns } from "./HeaderMenuWideList.vue?vue&type=template&id=24459ee7&scoped=true"
import script from "./HeaderMenuWideList.vue?vue&type=script&lang=js"
export * from "./HeaderMenuWideList.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuWideList.vue?vue&type=style&index=0&id=24459ee7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24459ee7",
  null
  
)

export default component.exports